var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C43.2534 100 36.7048 98.6793 30.5415 96.0709C24.5873 93.5505 19.2384 89.9516 14.6489 85.3511C10.0594 80.7616 6.44948 75.4127 3.92912 69.4585C1.32071 63.2952 0 56.7466 0 50C0 43.2534 1.32071 36.7048 3.92912 30.5415C6.44948 24.5873 10.0484 19.2384 14.6489 14.6489C19.2384 10.0594 24.5873 6.44948 30.5415 3.92912C36.7048 1.32071 43.2534 0 50 0C56.7466 0 63.2952 1.32071 69.4585 3.92912C75.4127 6.44948 80.7616 10.0484 85.3511 14.6489C89.9406 19.2384 93.5505 24.5873 96.0709 30.5415C98.6793 36.7048 100 43.2534 100 50C100 56.7466 98.6793 63.2952 96.0709 69.4585C93.5505 75.4127 89.9516 80.7616 85.3511 85.3511C80.7616 89.9406 75.4127 93.5505 69.4585 96.0709C63.2952 98.6793 56.7466 100 50 100Z",
    fill: "#099137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8279 56.5044C26.5243 60.8848 31.1908 67.7965 34.7898 72.342C36.4957 74.4881 39.5113 74.6862 41.4924 72.8042C52.9056 61.9744 63.5043 48.305 76.1831 29.3858C76.9205 28.2852 76.5463 26.7994 75.3797 26.172C74.4882 25.6988 73.3876 25.8749 72.6942 26.6123C58.6176 41.5143 51.4088 48.5912 37.4092 60.2464C37.4092 60.2464 32.9958 57.4399 27.6689 53.1366C26.5243 52.2121 24.8404 52.4212 23.9599 53.5989C23.3106 54.4353 23.2666 55.6019 23.8279 56.5044Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.dfdc949d2a45a3de665853d49ba165c8.svg";
export { ForwardRef as ReactComponent };